<template>
  <el-dialog
    :title="juming + '服务记录'"
    :visible.sync="serverMuneDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="800px"
    center>
    <el-table
      :data="serverData"
      border
      style="width: 100%">
      <el-table-column
        prop="content"
        label="服务类目"
       >
      </el-table-column>
      <el-table-column
        prop="integral"
        label="积分"
        width="100px"
        >
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="jinnuanbao"-->
<!--        label="金暖宝"-->
<!--        width="100px"-->
<!--      >-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="yinnuanbao"-->
<!--        label="银暖宝"-->
<!--        width="100px"-->
<!--      >-->
<!--      </el-table-column>-->
      <el-table-column
        prop="img"
        width="100px"
        label="佐证">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="upUrl + scope.row.result_img"
            :preview-src-list="[upUrl + scope.row.result_img]">
          </el-image>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex align-center justify-around margin-top-sm">
      <el-button class="padding-lr-xl" type="primary" @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>

import {getAdminServiceDetial} from "@/api/weilao";

export default {
  name: "serverContentDialog",
  props: {
    serverMuneDialog: {
      type: Boolean,
      default: false
    },
    serverMune: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  data() {
    return {
      upUrl: 'http://sjfadmin.emof.cn/',
      juming:'',
      serverData:[      ]
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    },
  },
  methods:{
    async getServiceDetial(){
      let _data = await getAdminServiceDetial(this.serverMune)
      this.serverData = _data.data.service_detail
      this.juming = _data.data.content
    },
    closeDialog(){
      this.$emit('cancelDialog',false)
    }
  },
  watch: {
    serverMuneDialog(){
      if(this.serverMuneDialog){
        this.getServiceDetial()
      }else{
        this.serverData = []
        this.juming = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
